var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background h-screen overflow-y-scroll"},[_c('Navbar'),_c('div',{staticClass:"flex h-full pt-32 items-center justify-center w-full p-5"},[_c('div',{staticClass:"text-center md:w-4/12 py-10"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }